var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitterWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(-0.009 -0.011)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 76.5,
    cy: 76.5,
    r: 76.5,
    transform: "translate(0.009 0.011)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M76.827,14.819A18.924,18.924,0,0,0,57.751,33.556c0,1.939.659,3.23.659,4.518a53.69,53.69,0,0,1-38.8-19.366,14.63,14.63,0,0,0-2.637,9.036c0,6.457,3.292,11.64,8.555,16.162a33.371,33.371,0,0,1-8.555-2.59c0,9.043,6.574,16.151,15.121,18.086a14.621,14.621,0,0,1-5.263.647c-.659,0-1.981-.647-3.3-.647,2.633,7.108,9.21,12.91,17.758,12.91-6.574,4.521-15.128,7.755-23.676,7.755h-4.6a55.984,55.984,0,0,0,28.935,8.406c34.856,0,53.929-28.427,53.929-52.974v-2.59a43.88,43.88,0,0,0,9.218-9.7,36.522,36.522,0,0,1-11.181,3.237c3.944-2.579,7.233-5.813,8.544-10.334a32.3,32.3,0,0,1-11.84,4.521C87.333,16.761,82.089,14.819,76.827,14.819Z",
    transform: "translate(17.538 23.498)",
    fill: "#273c49"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterWhite);
export default __webpack_public_path__ + "static/media/twitter-white.989969d80a26d65b7e4e276f30d55a49.svg";
export { ForwardRef as ReactComponent };